import React from 'react'
import { getPageProperties, getCPSCurrentYear } from '../../services/cps-school-api';
import SchoolMarkerSvg, { ICON_C, ICON_L, ICON_SCHOOL } from "../info/school-marker-svg";
import { renderToString } from 'react-dom/server'

const ucWords = (s: string): string => s.toLowerCase().replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, t => t.toUpperCase())

export const proximities = [
    { label: '1 mile', value: 1 },
    { label: '2 miles', value: 2 },
    { label: '3 miles', value: 3 },
    { label: '4 miles', value: 4 },
    { label: '5 miles', value: 5 },
    { label: '6 miles', value: 6 },
    { label: '7 miles', value: 7 },
    { label: '8 miles', value: 8 },
    { label: '9 miles', value: 9 },
    { label: '10 miles', value: 10 },
];



const schoolContent = (props) => {
    return <div className="school-value-popup">
        <h3>{props.SCHOOL_NM}</h3>
        <p>{props.SCHOOL_ADDR}</p>
        <hr />
        <p>
            <strong>Boundaries Served</strong><br />
            {props.BOUNDARYGR}
        </p>
    </div>
}

const araContent = (props) => {
    return <div className="single-value-popup">
        <h3>ARA Region {props.HS_ZONENUM}</h3>
        <hr />
        <p>{props.HS_ZONENAME}</p>
        <hr />
    </div>
}

const zipContent = (props) => {
    return <div className="single-value-popup">
        <h3>Zip Code</h3>
        <hr />
        <p>{props.ZIP}</p>
        <hr />
    </div>
}

const communityContent = (props) => {
    return <div className="single-value-popup">
        <h3>Neighborhood</h3>
        <hr />
        <p>{props.COMMUNITY}</p>
        <hr />
    </div>
}

const networkContent = (props) => {
    return <div className="network-popup">
        <h2 className="popup_title">
            {props.Network}
        </h2>
        <p>
            {props.Address}
        </p>
        <div className="popup_info">
            <p><b>Chief of Schools: </b>{props.Admin}</p>
            <p><b>Phone: </b>{props.Phone}</p>
        </div>
    </div>
}
/*
const networkContent = (props) => {
    return <div className="single-value-popup">
        <h3>Network</h3>
        <hr />
        <p>Network {props.K12_Network}</p>
        <hr />
    </div>
}
*/
const wardContent = (props) => {
    return <div className="single-value-popup">
        <h3>Ward {props.WARD}</h3>
        <hr />
        <p><strong>Alderman: </strong>{props.ALDERMAN}</p>
        <hr />
    </div>
}
const politicsContent = (props) => {
    return <div className="single-value-popup">
        <h3>{props.NAMELSAD}</h3>
        <hr />
        <p><strong>Rep: </strong>{props.Name}</p>
        <hr />
    </div>
}
const congressContent = (props) => {
    return <div className="single-value-popup">
        <h3>US Congressional District {props.Dist_Num}</h3>
        <hr />
        <p><strong>Rep: </strong>{props.Name}</p>
        <hr />
    </div>
}

const tierContent = (props) => {
    const year = currentCPSYear ? currentCPSYear : 2022;
    return <div className="tier-popup">
        <h3>{year} Tier: {props.Tier}</h3>
        <p>Valid for the application process during the {year}-{year + 1} School Year<br />
            Census Tract: {props.GEOID10}</p>
        <hr />

        <table>
            <tr><td>Estimated Median Family Income</td><td>{props.Estimated_}%</td></tr>
            <tr><td>Educational Attainment Score</td><td>{props.Educationa}%</td></tr>
            <tr><td>Single Parent Households</td><td>{props.F__of_Sing}%</td></tr>
            <tr><td>Owner Occupied Homes</td><td>{props.F__of_Owne}%</td></tr>
            <tr><td>Speak a Language Other than English</td><td>{props.F__of_Popu}%</td></tr>
            <tr><td>IAR Performance</td><td>{props.Weighted_A}%</td></tr>
            <tr><td>6-Factor Socioeconomic Score</td><td>{props.F6_Factor_}%</td></tr>
            <tr><td>Number of School Age Children</td><td>{props.Number_of_}</td></tr>
        </table>
        <hr />
    </div>
}

export const zipOverlay = { label: 'Zipcode', name: 'ZIP', year: 2020, clickContent: zipContent };
export const communityOverlay = { label: 'Community Areas', name: 'COMMUNITY', year: 2020, clickContent: communityContent };
export const networkOverlay = { label: 'Network', name: 'NETWORK', year: 2020, clickContent: networkContent };



export const defaultOverlays = [
    {
        groupName: 'Attendance Boundaries',
        options: [
            { label: 'Elementary School', name: 'BOUNDARY_ES', year: 2022, clickContent: schoolContent },
            { label: 'High School', name: 'BOUNDARY_HS', year: 2022, clickContent: schoolContent },
            { label: 'Charter School Preference ', name: 'BOUNDARY_CS', year: 2022, clickContent: schoolContent },
        ],
    },
    {
        groupName: 'Geographical',
        options: [
            { label: 'Elementary School Network', name: 'NETWORK_ES', year: 2022, clickContent: networkContent },
            { label: 'High School Network', name: 'NETWORK_HS', year: 2022, clickContent: networkContent },
            { label: 'ARA Regions', name: 'ARA', year: 2021, clickContent: araContent },
            { label: 'Community Areas', name: 'COMMUNITY', year: 2020, clickContent: communityContent },
            { label: 'CPS Tiers', name: 'TIER', year: 2021, clickContent: tierContent },
            { label: 'Zipcode', name: 'ZIP', year: 2020, clickContent: zipContent },

            { label: 'Bike Paths', noApi: true },
            { label: 'Transit', noApi: true },
        ],
    },

    {
        groupName: 'Political',
        options: [
            { label: 'Illinois House District', name: 'HOUSE', year: 2020, clickContent: politicsContent },

            { label: 'Illinois Senate District', name: 'SENATE', year: 2020, clickContent: politicsContent },
            { label: 'US Congressional District', name: 'CONGRESSIONAL', year: 2020, clickContent: congressContent },
            { label: 'Wards', name: 'WARD', year: 2020, clickContent: wardContent },
        ],
    }
];

const mapContentFunctionMap = new Map([
    ['networkcontent', networkContent],
    ['schoolcontent', schoolContent],
    ['communitycontent', communityContent],
    ['aracontent', araContent],
    ['zipcontent', zipContent],
    ['tiercontent', tierContent],
    ['politicscontent', politicsContent],
    ['congresscontent', congressContent],
    ['wardcontent', wardContent],
])

export const getMapYear = (name: string, mode): Promise<string | null> => {
    // first check any epi configured years
    return getOverlays(mode).then((overlays) => {
        const yearMap = new Map<string, string>();
        for (let group of overlays) {
            for (let option of group.options) {
                yearMap.set(option.name, option.year)
            }
        }

        let year = yearMap.get(name);
        // @ts-ignore
        if (window.mapOverrides) {
            // @ts-ignore
            const overrides = window.mapOverrides.filter(o => o.name == name);
            if (overrides.length) {
                year = overrides[0].year;
            }
        }
        return year;
    });

}

export let currentCPSYear = null;
export const getCPSYear = (): Promise<boolean> => {
    return getCPSCurrentYear().then(result => {
        currentCPSYear = Number(result.find(i => i.SystemDescription === 'MapsTier').ActiveYear);
        return true;
    })
}

export const getOverlays = (mode) => {
    return getPageProperties().then(props => {
        // they come from the backend with bad casing
        const propOverlays = props.overlaysFields ? props.overlaysFields : [];
        const backendOverlays = propOverlays.map(g => ({
            ...g,
            groupName: ucWords(g.groupName)
        }))
        // build the groups we have
        const startingGroups = defaultOverlays.map(g => g.groupName);
        const backendConf = backendOverlays.map(e => ({ groupName: e.groupName, options: [] }));
        const baseOverlays = mode == 'gocps' ? defaultOverlays : celOverlays;
        const overlays = [...baseOverlays, ...backendConf.filter(g => !startingGroups.includes(g.groupName))];
        for (let entry of backendOverlays) {
            const matchingGroup = overlays.find(group => group.groupName == entry.groupName);
            // check if this option exists by map name. overwrite if it does, add if it doesn't
            const matchingOption = matchingGroup.options.find(opt => opt.name == entry.name);
            if (matchingOption) {
                matchingOption.label = entry.label;
                matchingOption.year = entry.year;
                matchingOption.clickContent = mapContentFunctionMap.get(entry.clickContent);
            } else {
                matchingGroup.options.push({
                    label: entry.label,
                    name: entry.name,
                    year: entry.year,
                    clickContent: mapContentFunctionMap.get(entry.clickContent)
                })
            }
        }
        return overlays;
    });
}

export const celOverlays = [

    {
        groupName: '',
        options: [
            { label: 'Community Areas', name: 'COMMUNITY', year: 2020, clickContent: communityContent },
            { label: 'Zipcode', name: 'ZIP', year: 2020, clickContent: zipContent },

            { label: 'Bike Paths', noApi: true },
            { label: 'Transit', noApi: true },
        ],
    },
]

export const cpsLegend = [

    {
        groupName: '',
        options: [
            { label: 'Elementary School', icon: '/Static-Adage/img/search/GoCPS_CPS_ES_Map_Marker.svg', },
            { label: 'High School', icon: '/Static-Adage/img/search/GoCPS_CPS_HS_Map_Marker.svg', },
        ],
    },
    {
        groupName: '',
        options: [
            { label: 'Limited Availability', icon: '/Static-Adage/img/search/legend/yellow_circle.svg' },
            { label: 'Seats Available', icon: '/Static-Adage/img/search/legend/green_circle.svg' },
            { label: 'Waitlist', icon: '/Static-Adage/img/search/legend/red_circle.svg' },
        ],
    },
    {
        groupName: '',
        options: [
            { label: 'Compare', icon: '/Static-Adage/img/search/legend/check.svg', },
        ],
    }
];

export const prekLegend = [

    {
        groupName: '',
        options: [
            { label: 'Community Based School', icon: '/Static-Adage/img/search/legend/cel_marker.svg', },
            { label: 'CPS Based School', icon: '/Static-Adage/img/search/legend/cps_marker.svg', },
        ],
    },
    {
        groupName: '',
        options: [
            { label: 'Limited Availability', icon: '/Static-Adage/img/search/legend/yellow_circle.svg' },
            { label: 'Seats Available', icon: '/Static-Adage/img/search/legend/green_circle.svg' },
            { label: 'Waitlist', icon: '/Static-Adage/img/search/legend/red_circle.svg' },
        ],
    },
    {
        groupName: '',
        options: [
            { label: 'Compare', icon: '/Static-Adage/img/search/legend/check.svg', },
        ],
    }
];

export const progLegend = [
    {
        groupName: '',
        options: [
            {
                label: 'Local Bridge', icon: `data:image/svg+xml;charset=UTF-8;base64,${btoa(renderToString(
                    <SchoolMarkerSvg color={'#CF4016'} icon={ICON_L} />
                ))}`
            },
            {
                label: 'Central Bridge', icon: `data:image/svg+xml;charset=UTF-8;base64,${btoa(renderToString(
                    <SchoolMarkerSvg color={'#CF4016'} icon={ICON_C} />
                ))}`
            }
        ],
    }
];

export const mapStyles = [
    {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [
            { "lightness": 1 },
            { "saturation": -100 }
        ]
    }, {
        "featureType": "road.highway.controlled_access",
        "elementType": "geometry.stroke",
        "stylers": [
            { "saturation": -100 },
            { "visibility": "off" }
        ]
    }, {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            { "visibility": "off" }
        ]
    }, {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            { "lightness": 1 },
            { "saturation": -100 }
        ]
    }, {
        "featureType": "road",
        "elementType": "labels.text.stroke",
        "stylers": [
            { "saturation": -100 },
            { "gamma": 9.91 }
        ]
    }, {
        "featureType": "landscape",
        "stylers": [
            { "saturation": -70 }
        ]
    }, {
        "featureType": "administrative",
        "stylers": [
            { "visibility": "on" }
        ]
    }, {
        "featureType": "poi",
        "stylers": [
            { "saturation": -50 },
            { "visibility": "off" }
        ]
    }, {
        "featureType": "road",
        "elementType": "labels",
        "stylers": [
            { "saturation": -70 }
        ]
    }, {
        "featureType": "transit",
        "stylers": [
            { "saturation": -70 }
        ]
    }
]